import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import { useLockedFeatures } from '@/providers/LockedFeatures.provider';
import { usePermissions } from '@/providers/Permissions.provider';
import usePreFundingEnabled from '@/hooks/usePreFundingEnabled';
import WebhooksPage from './Webhooks/WebhooksPage';
import AuthorizedIpsPage from './AuthorizedIps/AuthorizedIpsPage';
import BrandingSettingsPage from './BrandingSettings/BrandingSettingsPage';
import ElinxSettingsPage from './ELinx/ElinxSettingsPage';
import EmailDomainPage from './DomainSetup/EmailDomainPage';
import PreFundingSettings from './PreFundingSettings/PreFundingSettings';

export default function SettingsPageRoutes() {
  const lockedFeatures = useLockedFeatures();
  const featureFlags = useModuleFeatureFlag('settings');
  const { permissions } = usePermissions();
  const preFundingEnabled = usePreFundingEnabled();

  // Matches useSettingsLockState's Branding rule: Onboarding branding is partner-only.
  const brandingUnlocked =
    !!lockedFeatures.BrandingELinxEnabled ||
    !!lockedFeatures.BrandingEmailEnabled ||
    !!lockedFeatures.BrandingPortalEnabled;

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path={['/settings/webhooks', '/settings/webhooks/history']}
        component={WebhooksPage}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/settings/authorized-ips"
        component={AuthorizedIpsPage}
      />

      <ProtectedRoute
        isAllowed={!!lockedFeatures.EmailDomainEnabled && featureFlags.isEnabled}
        showPermission
        path="/settings/domain-setup"
        component={EmailDomainPage}
      />

      <ProtectedRoute
        isAllowed={brandingUnlocked && featureFlags.isEnabled}
        showPermission
        exact
        path="/settings/brand-settings"
        component={BrandingSettingsPage}
      />

      <ProtectedRoute
        isAllowed={!!lockedFeatures.PayLinkEnabled && featureFlags.isEnabled}
        showPermission
        exact
        path="/settings/elinx"
        component={ElinxSettingsPage}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled && !!permissions.ViewSettings && preFundingEnabled}
        showPermission
        exact
        path="/settings/pre-funding"
        component={PreFundingSettings}
      />
    </Switch>
  );
}
